import { Language } from "@/components/LanguageSwitcher";

export const content = {
  sv: {
    header: {
      navigation: {
        services: "Tjänster",
        about: "Om oss",
        process: "Process",
        pricing: "Priser",
        contact: "Kontakt"
      },
      cta: "Få prisförslag",
      ctaUrl: "https://volym.typeform.com/to/vvm1IndH?utm_source=xxxxx&utm_campaign=xxxxx&utm_content=xxxxx"
    },
    hero: {
      badge: "🎬 Filmstudio för företag",
      headline: "Nästa generations filmproduktionsbolag",
      subheadline: "Efter 15 år i filmbranschen har vi nu med hjälp av ny teknik skapat en process som kombinerar professionella filmproducenter med kostnadseffektiviteten hos den senaste tekniken för att möta våra högt ställda Nordiska kvalitetskrav.",
      benefits: [
        "2d/3d-visualisering",
        "Snabb leverans",
        "Hybrid AI-workflow"
      ],
      cta: {
        primary: "Skapa eller testa ditt filmprojekt här",
        secondary: "Se demo"
      }
    },
    stats: {
      stats: [
        {
          number: "15 år",
          label: "Erfarenhet inom filmbranschen"
        },
        {
          number: "100+",
          label: "Slutförda produktioner"
        },
        {
          number: "SME & Enterprise",
          label: "Vi arbetar med både små & stora marknadsteam"
        }
      ]
    },
    services: {
      title: "Våra filmtjänster",
      subtitle: "Från idé till färdig video på rekordtid med vår AI-hybridmetod",
      services: [
        {
          title: "Reklamfilm",
          description: "Skroll-stoppande videopaket för SoMe & Ads i rätt format & längder",
          features: ["AI-hybrid process", "SoMe & Ads", "Formatversioner"]
        },
        {
          title: "Videoavatar",
          description: "Klona dig själv eller skapa en virtuell säljare som aldrig har en \"bad hair day\"",
          features: ["Realistiska avatarer", "Naturlig röst", "Anpassningsbara"]
        },
        {
          title: "Explainer-video",
          description: "Animerade videor som förklarar komplexa koncept på ett enkelt och engagerande sätt.",
          features: ["2D/3D-animation", "Storytelling", "Varumärkesanpassning"]
        },
        {
          title: "Animerad film",
          description: "Underhållande animerade filmer för marknadsföring, utbildning eller underhållning",
          features: ["Helt anpassningsbara", "Fritt uttryck", "Snabb leverans"]
        }
      ]
    },
    process: {
      title: "70/30 (AI/Människa)",
      subtitle: "70% AI-automation kombinerat med 30% manuellt arbete från våra filmexperter säkerställer högsta kvalitet",
      description: "En hybrid-lösning är den bästa lösningen just nu. Generativ AI & automation är en fantastisk teknik men den behöver definitivt forfarande styrning och manuell kontroll i delar för att leverera hög kvalitet rakt igenom.",
      steps: [
        {
          title: "Skapa ditt manus",
          description: "Fyll i vårt enkla formulär med dina önskemål och material. Vår AI analyserar direkt dina behov och förbereder produktionen."
        },
        {
          title: "AI + Expertis",
          description: "70% AI-automation skapar grunden, medan 30% manuellt arbete från våra filmexperter säkerställer nordisk kvalitet och kulturell relevans."
        },
        {
          title: "Leverans & support",
          description: "Få din färdiga video inom 2-5 dagar med 2 vändor korr tills du är 100% nöjd."
        }
      ]
    },
    volumePricing: {
      title: "Volymrabatter - ju fler filmer, desto lägre pris",
      subtitle: "Spara pengar genom att beställa flera videor samtidigt. Perfekt för kampanjer och serier.",
      packages: [
        {
          videos: "3 filmer",
          discount: "10% rabatt",
          description: "Perfekt för en mindre kampanj"
        },
        {
          videos: "6 filmer",
          discount: "20% rabatt", 
          description: "Idealiskt för en komplett serie"
        },
        {
          videos: "10 filmer",
          discount: "30% rabatt",
          description: "Bästa värdet för stora projekt"
        }
      ]
    },
    pricing: {
      heroTitle: "🎬 Volym Studio – Credit Packages",
      heroSubtitle: "Köp credits och använd dem fritt över tid och på olika projekt. Ju större paket, desto mer får du för pengarna.",
      creditPackages: [
        {
          name: "Small",
          credits: "60",
          price: "18 000",
          pricePerCredit: "300 SEK",
          examples: "Ex. 1 x 60s eller 1 x 30s & 1 x 15s",
          icon: "package"
        },
        {
          name: "Medium",
          credits: "120",
          price: "33 600",
          pricePerCredit: "280 SEK",
          examples: "120 credits för 280 SEK",
          popular: true,
          icon: "trending-up"
        },
        {
          name: "Large",
          credits: "300", 
          price: "78 000",
          pricePerCredit: "260 SEK",
          examples: "300 credits = 260 SEK / credit",
          icon: "zap"
        }
      ],
      howCreditsWork: {
        title: "✅ Hur fungerar credits?",
        rules: [
          "1 sek färdig film = 1 credit",
          "Varje extra film = +5 credits",
          "Extra språk +3 credits",
          "Extra kortversion +3 credits"
        ],
        note: "👉 Credits kan användas fritt över tid och på olika projekt. Ju större paket, desto mer får du för pengarna."
      }
    },
    contact: {
      title: "Redo att starta ditt videoprojekt?",
      subtitle: "Kontakta oss idag så hjälper vi dig att skapa engagerande videocontent som får resultat",
      form: {
        name: "Namn",
        email: "E-post",
        company: "Företag",
        service: "Välj tjänst",
        message: "Meddelande",
        submit: "Skicka förfrågan",
        services: ["Reklamfilm", "Videoavatarer", "Förklaringsvideofilmer", "Animerade filmer"]
      },
      contact: {
        email: "info@explainervideo.se",
        phone: "+46 8 123 456 78",
        address: "Stockholm, Sverige"
      },
      meeting: {
        question: "Vill du boka ett kort möte?",
        button: "Ja"
      }
    },
    footer: {
      company: "Explainer Video",
      rights: "Alla rättigheter förbehållna."
    },
    about: {
      title: "Om oss",
      subtitle: "Volymstudio är den självklara partnern för modern, kostnadseffektiv och högpresterande filmproduktion i Sverige",
      history: {
        title: "Hållbar AI-användning",
        content1: "Det kommer rapporter om att energiförbrukningen ökar explosionsartat i takt med AI-utvecklingen. Vi vill göra vad vi kan för att hålla nere energiförbrukningen av AI-användningen. Därför har vi slagit samman prompter för att skicka färre API-anrop och försöker i första hand lösa problem med automation istället för att slösa på onödiga och komplexa AI-svar. Vi använder även Google Cloud i Finland som använder förnyelsebar energi för sina datacenter."
      },
      future: {
        title: "Framtiden är här",
        content1: "Idag har vi utvecklat en unik 70/30-metod som kombinerar AI-teknikens effektivitet med våra filmexperters kreativitet och kvalitetstänk. Detta ger oss möjlighet att leverera professionella videor snabbare och mer kostnadseffektivt än någonsin tidigare.",
        content2: "AI är fantastisk teknologi när den används rätt, men den behöver definitivt hjälp av oss människor för att säkerställa våra höga kvalitetskrav i Norden."
      },
      expertise: {
        title: "Vår expertis",
        items: [
          {
            number: "15",
            title: "År av erfarenhet",
            description: "Djup kunskap inom filmbranschen och visuell kommunikation"
          },
          {
            number: "100+",
            title: "Nöjda kunder",
            description: "Från SME till Enterprise - vi arbetar med alla storlekar"
          },
          {
            number: "AI",
            title: "Framtidsteknologi",
            description: "Pionjärer inom AI-driven videoproduktion i Sverige"
          }
        ]
      },
      whyChoose: {
        title: "Varför välja oss?",
        items: [
          {
            title: "15 års erfarenhet",
            description: "Djup branschkunskap och beprövade metoder för framgångsrika videoproduktioner."
          },
          {
            title: "Experter på animation",
            description: "Vi var bland de första i Sverige att erbjuda explainer videos och animerade reklamfilmer."
          },
          {
            title: "Obegränsad storytelling",
            description: "Animation erbjuder oändligt många fler kommunikativa möjligheter än traditionellt filmat material."
          },
          {
            title: "AI + Mänsklig expertis",
            description: "Vår unika 70/30-metod kombinerar AI-effektivitet med mänsklig kreativitet."
          },
          {
            title: "Nordisk kvalitet",
            description: "Vi säkerställer att alla videor möter våra högt ställda nordiska kvalitetskrav."
          },
          {
            title: "Snabb leverans",
            description: "Från idé till färdig video på rekordtid tack vare vår AI-drivna process."
          }
        ]
      }
    },
    faq: {
      title: "Vanliga frågor",
      subtitle: "Svar på de vanligaste frågorna om vår AI-hybridvideo-tjänst",
      faqs: [
        {
          question: "Hur lång tid tar produktionen?",
          answer: "Tack vare vår AI-hybrid-metod levererar vi de flesta projekt inom 5-10 arbetsdagar. För enklare explainer-videos kan det gå ännu snabbare, medan mer komplexa produktioner kan ta upp till 2 veckor. Vi ger alltid en tydlig tidslinje när projektet startar."
        },
        {
          question: "Vad ingår i priset?",
          answer: "Priset inkluderar komplett produktion från manus till färdig video, upp till 3 revisions-rundor, professionell röstläggning, bakgrundsmusik, grafik och animationer. Ni får videorna i de format ni behöver för webben, sociala medier och presentationer."
        },
        {
          question: "Hur många ändringar kan vi göra?",
          answer: "Vi inkluderar 3 revisions-rundor i alla våra paket. Det räcker nästan alltid för att nå det perfekta resultatet. Behöver ni fler ändringar erbjuder vi detta till en rimlig extra kostnad."
        },
        {
          question: "Vilka filformat levererar ni?",
          answer: "Vi levererar i alla gängse format: MP4 för webb och presentationer, olika upplösningar för sociala medier (Instagram, LinkedIn, YouTube), och även specialformat om ni har specifika behov."
        },
        {
          question: "Kan ni hantera brådskande projekt?",
          answer: "Ja, vi erbjuder rush-leveranser för brådskande projekt. Beroende på projektets omfattning kan vi ofta leverera inom 2-3 arbetsdagar mot en mindre extra kostnad."
        },
        {
          question: "Vad händer om vi inte är nöjda?",
          answer: "Vi står bakom vårt arbete. Om ni inte är nöjda efter våra inkluderade revisioner, arbetar vi vidare tills ni är helt nöjda eller återbetalar pengarna. Vår målsättning är alltid 100% nöjda kunder."
        },
        {
          question: "Arbetar ni med internationella kunder?",
          answer: "Absolut! Vi producerar videos på svenska, engelska och andra språk. Vår plattform fungerar smidigt oavsett var ni befinner er, och vi har erfarenhet av att arbeta med kunder i hela Europa och USA."
        },
        {
          question: "Vad är skillnaden mellan AI och traditionell videoproduktion?",
          answer: "Vår AI-hybrid-metod kombinerar det bästa från båda världarna: AI sköter tidskrävande uppgifter som första utkast och grundredigering, medan erfarna filmproffs står för kreativitet, storytelling och den slutliga finishen. Resultatet blir högre kvalitet till lägre kostnad och kortare leveranstid."
        }
      ]
    },
    videoAvatars: {
      hero: {
        title: "Realistiska AI-avatarer",
        subtitle: "AI-avatarer har visat sig vara en guldgruva inom annonsering då de generellt sänker CPA kraftigt. Det betyder bättre effekt för dina kampanjer. Dessutom behöver du inte fundera på om du råkar ha en \"bad hair day\" 😉",
        cta: {
          primary: "Få prisförslag",
          secondary: "Se demo"
        }
      },
      features: [
        {
          title: "Klona dig själv",
          description: "Avancerad AI skapar en trovärdig Avatar av dig med naturliga ansiktsuttryck och gester. Träna med förinspelat videomaterial, sedan är det bara att skapa videoklipp genom att prompta."
        },
        {
          title: "Naturlig röst",
          description: "Träna din egen röst eller använd en befintlig och skapa filmer på 40+ språk"
        },
        {
          title: "Skapa er AI-säljare",
          description: "Vad sägs om en säljare som aldrig stakar sig, har karisma, rätt argument och aldrig sover? Välj er färdiga virtuella säljar-avatar."
        }
      ],
      pricing: {
        title: "Våra paket",
        subtitle: "Välj det paket som passar ditt företag bäst",
        packages: [
          {
            name: "Företagspaketet",
            subtitle: "För mindre företag",
            features: [
              {
                name: "Skapande av Avatar (Grundnivå)",
                description: "Engångskostnad",
                price: "9 000 kr"
              },
              {
                name: "Videoproduktion (upp till 60s)",
                description: "Per film",
                price: "3 000 kr"
              },
              {
                name: "Valfritt: Studioinspelning träningsmaterial inkl. ljussättning",
                description: "Tillval",
                price: "9 000 kr"
              }
            ],
            cta: "Få prisförslag"
          },
          {
            name: "Premiumpaketet",
            subtitle: "För större företag / Koncerner",
            popular: true,
            features: [
              {
                name: "Skapande av Avatar (Premiumkvalitet)",
                description: "Engångskostnad",
                price: "19 000 kr"
              },
              {
                name: "Videoproduktion (upp till 60s)",
                description: "Per film",
                price: "5 000 kr"
              },
              {
                name: "Valfritt: Studioinspelning träningsmaterial inkl. ljussättning",
                description: "Tillval",
                price: "9 000 kr"
              }
            ],
            cta: "Få prisförslag"
          }
        ]
      }
    }
  },
  en: {
    header: {
      navigation: {
        services: "Services",
        about: "About Us",
        process: "Process",
        pricing: "Pricing",
        contact: "Contact"
      },
      cta: "Request Quote",
      ctaUrl: "https://volym.typeform.com/to/eej3bxU6?utm_source=xxxxx&utm_campaign=xxxxx&utm_content=xxxxx"
    },
    hero: {
      badge: "🎬 AI-driven film studio",
      headline: "Next Generation Film Production with AI",
      subheadline: "After 15 years in the film industry, we have created a process that combines AI technology's efficiency with professional film producers to create a truly cost-effective service that meets our high Nordic quality standards.",
      benefits: [
        "2D/3D visualization",
        "Fast delivery", 
        "Hybrid AI-workflow"
      ],
      cta: {
        primary: "Create or test your script here",
        secondary: "Watch Demo"
      }
    },
    stats: {
      stats: [
        {
          number: "15 years",
          label: "Experience in film industry"
        },
        {
          number: "100+",
          label: "Completed productions"
        },
        {
          number: "SME & Enterprise",
          label: "We work with both small & large marketing teams"
        }
      ]
    },
    services: {
      title: "Our AI-Powered Video Services",
      subtitle: "From idea to finished video in record time with our AI technology",
      services: [
        {
          title: "Commercial Film",
          description: "Create engaging video ads that convert with AI-generated content and professional editing.",
          features: ["AI Scripts", "Auto-editing", "Audience Targeting"]
        },
        {
          title: "Video Avatars",
          description: "Personal AI avatars that can deliver your message in perfect Swedish or English.",
          features: ["Realistic Avatars", "Natural Voice", "Customizable"]
        },
        {
          title: "Explainer Videos",
          description: "Animated videos that explain complex concepts in a simple and engaging way.",
          features: ["2D/3D Animation", "Storytelling", "Brand Customization"]
        },
        {
          title: "Animated Films",
          description: "Fully animated films for marketing, education, or entertainment purposes.",
          features: ["Fully Customizable", "Professional Quality", "Fast Delivery"]
        }
      ]
    },
    process: {
      title: "Our Unique 70/30 Method",
      subtitle: "70% AI automation combined with 30% manual work from our film experts ensures the highest quality",
      description: "AI is fantastic technology when used correctly, but it definitely needs help from us humans to ensure our high quality standards in the Nordic region.",
      steps: [
        {
          title: "Order Online",
          description: "Fill out our simple form with your requirements and materials. Our AI instantly analyzes your needs and prepares production."
        },
        {
          title: "AI + Expertise",
          description: "70% AI automation creates the foundation, while 30% manual work from our film experts ensures Nordic quality and cultural relevance."
        },
        {
          title: "Delivery & Support",
          description: "Receive your finished video within 24-48 hours with continuous support throughout the process from our Swedish experts."
        }
      ]
    },
    volumePricing: {
      title: "Volume Discounts - more videos, lower price per video",
      subtitle: "Save money by ordering multiple videos at once. Perfect for campaigns and series.",
      packages: [
        {
          videos: "3 videos",
          discount: "10% discount",
          description: "Perfect for a small campaign"
        },
        {
          videos: "6 videos", 
          discount: "20% discount",
          description: "Ideal for a complete series"
        },
        {
          videos: "10 videos",
          discount: "30% discount",
          description: "Best value for large projects"
        }
      ]
    },
    pricing: {
      heroTitle: "🎬 Volym Studio – Credit Packages",
      heroSubtitle: "Buy credits and use them freely over time and across different projects. The larger the package, the more you get for your money.",
      creditPackages: [
        {
          name: "Starter",
          credits: "50",
          price: "12,500",
          pricePerCredit: "250 SEK",
          examples: "1 × 50s film or 2–3 short films",
          icon: "package"
        },
        {
          name: "Pro", 
          credits: "100",
          price: "23,000",
          pricePerCredit: "230 SEK",
          examples: "1 × 90s film or 3 × 30s films",
          popular: true,
          icon: "trending-down"
        },
        {
          name: "Enterprise",
          credits: "250", 
          price: "55,000",
          pricePerCredit: "220 SEK",
          examples: "2 × 90s films + multiple 30s / 15s cutdowns",
          icon: "zap"
        }
      ],
      howCreditsWork: {
        title: "✅ How do credits work?",
        rules: [
          "1 sec finished film = 1 credit",
          "Each additional film = +5 credits",
          "Extra language +3 credits",
          "Extra cutdown 3 credits"
        ],
        note: "👉 Credits can be used freely over time and across different projects. The larger the package, the more you get for your money."
      }
    },
    contact: {
      title: "Ready to Start Your Video Project?",
      subtitle: "Contact us today and we'll help you create engaging video content that delivers results",
      form: {
        name: "Name",
        email: "Email",
        company: "Company",
        service: "Select Service",
        message: "Message",
        submit: "Send Inquiry",
        services: ["Commercial Film", "Video Avatars", "Explainer Videos", "Animated Films"]
      },
      contact: {
        email: "info@explainervideo.se",
        phone: "+46 8 123 456 78",
        address: "Stockholm, Sweden"
      },
      meeting: {
        question: "Would you like to book a short meeting?",
        button: "Yes"
      }
    },
    footer: {
      company: "Explainer Video",
      rights: "All rights reserved."
    },
    about: {
      title: "About Us",
      subtitle: "Our journey from traditional film production to AI-driven video production",
      history: {
        title: "Our History",
        content1: "With 15 years of experience in the film industry, we have been pioneers in animated corporate communication in Sweden. We were actually among the first in Sweden to offer explainer videos and animated commercials.",
        content2: "Over the years, we have helped over 100 companies explain complex ideas in a simple and engaging way through animation. From BRIS to the Swedish Football Association, from Epiroc to Specsavers - we have created films that truly make a difference."
      },
      future: {
        title: "The Future is Here",
        content1: "Today we have developed a unique 70/30 method that combines AI technology's efficiency with our film experts' creativity and quality mindset. This enables us to deliver professional videos faster and more cost-effectively than ever before.",
        content2: "AI is fantastic technology when used correctly, but it definitely needs help from us humans to ensure our high quality standards in the Nordic region."
      },
      expertise: {
        title: "Our Expertise",
        items: [
          {
            number: "15",
            title: "Years of Experience",
            description: "Deep knowledge in the film industry and visual communication"
          },
          {
            number: "100+",
            title: "Satisfied Clients",
            description: "From SME to Enterprise - we work with all sizes"
          },
          {
            number: "AI",
            title: "Future Technology",
            description: "Pioneers in AI-driven video production in Sweden"
          }
        ]
      },
      whyChoose: {
        title: "Why Choose Us?",
        items: [
          {
            title: "15 Years of Experience",
            description: "Deep industry knowledge and proven methods for successful video productions."
          },
          {
            title: "Animation Experts",
            description: "We were among the first in Sweden to offer explainer videos and animated commercials."
          },
          {
            title: "Unlimited Storytelling",
            description: "Animation offers infinitely more communicative possibilities than traditional filmed material."
          },
          {
            title: "AI + Human Expertise",
            description: "Our unique 70/30 method combines AI efficiency with human creativity."
          },
          {
            title: "Nordic Quality",
            description: "We ensure all videos meet our high Nordic quality standards."
          },
          {
            title: "Fast Delivery",
            description: "From idea to finished video in record time thanks to our AI-driven process."
          }
        ]
      }
    },
    faq: {
      title: "Frequently Asked Questions",
      subtitle: "Answers to the most common questions about our AI-enhanced video service",
      faqs: [
        {
          question: "How long does production take?",
          answer: "Thanks to our AI-hybrid method, we deliver most projects within 5-10 business days. For simpler explainer videos, it can be even faster, while more complex productions may take up to 2 weeks. We always provide a clear timeline when the project starts."
        },
        {
          question: "What's included in the price?",
          answer: "The price includes complete production from script to finished video, up to 3 revision rounds, professional voiceover, background music, graphics and animations. You get the videos in the formats you need for web, social media and presentations."
        },
        {
          question: "How many changes can we make?",
          answer: "We include 3 revision rounds in all our packages. This is almost always enough to achieve the perfect result. If you need more changes, we offer this at a reasonable additional cost."
        },
        {
          question: "What file formats do you deliver?",
          answer: "We deliver in all common formats: MP4 for web and presentations, various resolutions for social media (Instagram, LinkedIn, YouTube), and also special formats if you have specific needs."
        },
        {
          question: "Can you handle urgent projects?",
          answer: "Yes, we offer rush deliveries for urgent projects. Depending on the scope of the project, we can often deliver within 2-3 business days for a small additional cost."
        },
        {
          question: "What happens if we're not satisfied?",
          answer: "We stand behind our work. If you're not satisfied after our included revisions, we continue working until you're completely satisfied or refund the money. Our goal is always 100% satisfied customers."
        },
        {
          question: "Do you work with international clients?",
          answer: "Absolutely! We produce videos in Swedish, English and other languages. Our platform works smoothly regardless of where you are located, and we have experience working with clients throughout Europe and the USA."
        },
        {
          question: "What's the difference between AI and traditional video production?",
          answer: "Our AI-hybrid method combines the best of both worlds: AI handles time-consuming tasks like first drafts and basic editing, while experienced film professionals handle creativity, storytelling and the final polish. The result is higher quality at lower cost and shorter delivery time."
        }
      ]
    },
    videoAvatars: {
      hero: {
        title: "Realistic AI Avatars",
        subtitle: "AI avatars have proven to be a goldmine in advertising as they generally significantly reduce CPA. This means better performance for your campaigns. Plus, you never have to worry about having a \"bad hair day\" 😉",
        cta: {
          primary: "Request Quote",
          secondary: "Watch Demo"
        }
      },
      features: [
        {
          title: "Clone Yourself",
          description: "Advanced AI creates a believable avatar of you with natural facial expressions and gestures. Train with pre-recorded video material, then just create video clips by prompting."
        },
        {
          title: "Natural Voice",
          description: "Train your own voice or use an existing one and create movies in 40+ languages"
        },
        {
          title: "Create Your AI Salesperson",
          description: "How about a salesperson who never stutters, has charisma, the right arguments and never sleeps? Choose your ready-made virtual sales avatar."
        }
      ],
      pricing: {
        title: "Our Packages",
        subtitle: "Choose the package that best suits your business",
        packages: [
          {
            name: "Business Package",
            subtitle: "For smaller companies",
            features: [
              {
                name: "Avatar Creation (Basic Level)",
                description: "One-time cost",
                price: "9,000 SEK"
              },
              {
                name: "Video Production (up to 60s)",
                description: "Per film",
                price: "3,000 SEK"
              },
              {
                name: "Optional: Studio recording training material incl. lighting",
                description: "Add-on",
                price: "9,000 SEK"
              }
            ],
            cta: "Choose Business Package"
          },
          {
            name: "Premium Package",
            subtitle: "For larger companies / Corporations",
            popular: true,
            features: [
              {
                name: "Avatar Creation (Premium Quality)",
                description: "One-time cost",
                price: "19,000 SEK"
              },
              {
                name: "Video Production (up to 60s)",
                description: "Per film",
                price: "5,000 SEK"
              },
              {
                name: "Optional: Studio recording training material incl. lighting",
                description: "Add-on",
                price: "9,000 SEK"
              }
            ],
            cta: "Choose Premium Package"
          }
        ]
      }
    }
  }
} as const;

export type ContentType = typeof content.sv;
